import Box from 'UIKit/Box/Box'
import { RowMiddle } from 'layout/Components/Row'
import styled from 'styled-components'

export const StyledMarkPointContainer = styled(RowMiddle)`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
`

export const StyledMarkedProgressPoint = styled(Box)`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #494f5c;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    bottom: 2px;
    left: 2px;
    right: 2px;
    padding: 2px;
    border-radius: 50%;
    border: 1px solid #3b3f4a;
    z-index: 10;
  }
`

export const StyledStepOverPoints = styled(Box)<{ $width: number }>`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  height: 4px;
  width: ${({ $width }) => $width}% !important;
  border-top-left-radius: 32px;
  border-bottom-left-radius: 32px;
`
